import { render, staticRenderFns } from "./Redeem.vue?vue&type=template&id=0f6a2e97&scoped=true&"
import script from "./Redeem.vue?vue&type=script&lang=js&"
export * from "./Redeem.vue?vue&type=script&lang=js&"
import style0 from "./Redeem.vue?vue&type=style&index=0&id=0f6a2e97&scoped=true&lang=css&"
import style1 from "./Redeem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a2e97",
  null
  
)

export default component.exports